<template>
  <section data-nosnippet style="margin:0 -20px;">
    <b-container fluid class="p-0">
      <b-row class="kub-price-summary" style="padding:15px 20px 80px;">
        <b-col cols="12" sm="5" md="5" lg="6" :class="{'mb-3': !md}">
          <div class="mb-4">
            <span class="font-weight-bold">Herstellerinformationen</span><br />
            <small>Angaben gemäß der allgemeinen Produktsicherheitsrichtlinie (Verordnung (EU) 2023/988 - GPSR)</small>
            <ul class="mt-2">
              <li><b-icon :icon="contact.homepage.icon" class="mr-2"></b-icon>{{contact.company.content}}, {{contact.street.content}} {{contact.number.content}}, {{contact.zip.content}} {{contact.city.content}}</li>
              <li><b-icon :icon="contact.phone.icon" class="mr-2"></b-icon><a class="kub-hersteller-link" :href="'tel:' + contact.phoneTo.content">{{ contact.phone.content }}</a></li>
              <li><b-icon :icon="contact.mail.icon" class="mr-2"></b-icon><a class="kub-hersteller-link" :href="'mailto:' + contact.mail.content">{{ contact.mail.content }}</a></li>
            </ul>
          </div>
          <b-form-textarea
            id="textarea"
            :placeholder="price.placeholder"
            v-model="note"
            rows="2"
            max-rows="4"
          ></b-form-textarea>
        </b-col>
        <b-col cols="12" offset-sm="1" offset-md="2" offset-lg="3" sm="6" md="5" lg="3">
          <b-row>
            <b-col cols="12" class="mb-4">
              <div class="text-right font-weight-bold" style="font-size:1.75em;">{{formComplete ? new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(calcUnitPrice) : '--,- &nbsp;&euro;'}}</div>
              <div class="w-100"></div>
              <div class="text-right"><small>{{price.salesTaxBefore}} <span v-if="checkVAT">0%</span> {{price.salesTaxAfter}} <span class="kub-btn-shipping" @click="$bvModal.show('kub-shippingCosts')">{{price.shipping}}</span></small></div>
              <div class="w-100"></div>
              <div class="text-right"><small><strong>{{price.deliveryTime}}</strong>: ca. {{formComplete ? calcDeliveryTime : '--'}}</small></div>
            </b-col>
            <b-col cols="12">
              <b-button type="submit" href="#" block variant="link" class="kub-btn-filled text-decoration-none p-2" :disabled="calcDeliveryTime === null" @click="addToShoppingCart()">{{price.addButton}}</b-button>
            </b-col>
            <b-col cols="12" class="mt-2" v-if="(calcUnitPrice <= (checkVAT ? Math.round((minOrder / (1 + VAT) + Number.EPSILON) * 100) / 100 : minOrder) && formComplete)">
              <small>
                <strong>Hinweise:</strong>
                <ul style="list-style:disc;">
                  <li>Der Mindestpreis pro Plane beträgt {{new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(checkVAT ? Math.round((minOrder / (1 + VAT) + Number.EPSILON) * 100) / 100 : minOrder)}}</li>
                </ul>
              </small>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-modal id="kub-missingInput" centered :title="price.missingInput.title" title-tag="h2">
        <div v-html="price.missingInput.content"></div>
        <ul style="list-style:disc;list-style-position:inside;">
          <li v-if="!formComplete">{{price.missingInput.form}}</li>
          <li v-if="!formComplete || !materialComplete">{{price.missingInput.material}}</li>
          <li v-if="!formComplete || !materialComplete">{{price.missingInput.rand}}</li>
        </ul>
        <template #modal-footer="{ ok }">
          <b-button class="kub-btn" size="sm" @click="ok()">
            <span class="pl-2 pr-2">OK</span>
          </b-button>
        </template>
      </b-modal>
      <b-modal id="kub-shippingCosts" centered :title="price.shipping" title-tag="h2">
        <app-shipping-costs></app-shipping-costs>
        <template #modal-footer="{ ok }">
          <b-button class="kub-btn" size="sm" @click="ok()">
            <span class="pl-2 pr-2">OK</span>
          </b-button>
        </template>
      </b-modal>
    </b-container>
  </section>
</template>

<script>
import DataSetup from '../../../data/main/config/setup/setup'
import DataSummary from '../../../data/main/summary/summary'
import DataPrice from '../../../data/main/config/price'
import DataService from '../../../services/DataService'
import DataContact from '../../../data/general/contact'

import ShippingCosts from './ShippingCosts.vue'

import { mapGetters, mapActions } from 'vuex'

import { createHelpers } from 'vuex-map-fields'

const { mapFields } = createHelpers({
  getterType: 'getConfigurationField',
  mutationType: 'updateConfigurationField'
})

export default {
  data () {
    return {
      setupComponents: DataSetup.components,
      summaryComponents: DataSummary.components,
      price: DataPrice.price,
      minOrder: null,
      contact: DataContact.contact,
      VAT: null
    }
  },
  components: {
    appShippingCosts: ShippingCosts
  },
  methods: {
    ...mapActions([
      'setConfigRand',
      'changeStatusRand',
      'addConfiguration',
      'setConfObj',
      'increaseTabIndex',
      'clearSummary',
      'changeView',
      'setConfigPrice',
      'setConfigOesenTotal',
      'setConfigHohlsaum',
      'setConfigDrehverschluss',
      'setVatRateFromBasics'
    ]),
    addToShoppingCart () {
      if (!this.materialComplete) {
        this.$bvModal.show('kub-missingInput')
      } else {
        this.setConfigRand(this.randSides)
        this.setConfigPrice(this.calcUnitPriceBrutto)
        if (this.activeOesenArt) {
          this.setConfigOesenTotal(this.calcOesenAnzahlTotal)
        }

        this.setConfigHohlsaum(this.activeHohlsaum)
        this.setConfigDrehverschluss(this.activeDrehverschluss)

        this.addConfiguration()
        this.setConfObj({
          code: { formType: this.formTypeCode, formSize: this.formSize, materialType: this.materialTypeCode, color: this.materialColorCode, rand: this.randSides, hohlsaum: this.configuration.hohlsaum, drehverschluss: this.configuration.drehverschluss, note: this.configuration.note },
          name: { formType: this.formType, formSize: this.formSize, materialType: this.materialType, color: this.materialColor.color, rand: this.randSides, hohlsaum: this.configuration.hohlsaum, drehverschluss: this.configuration.drehverschluss, note: this.configuration.note }
        })
        this.increaseTabIndex()
        if (this.shoppingCartComplete) {
          this.$root.$emit('bv::toggle::collapse', this.summaryComponents.shoppingCart.toggle)
        }
        this.clearSummary()
        this.changeView({ x: 0, y: 0 })
        if (!this.randComplete) {
          this.changeStatusRand()
          this.$root.$emit('bv::toggle::collapse', this.setupComponents.rand.toggle)
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'lg',
      'md',
      'randSides',
      'formType',
      'formTypeCode',
      'formSize',
      'materialType',
      'materialTypeCode',
      'materialColor',
      'materialColorCode',
      'shoppingCartComplete',
      'materialComplete',
      'formComplete',
      'randComplete',
      'configuration',
      'calcUnitPrice',
      'calcUnitPriceBrutto',
      'calcDeliveryTime',
      'calcOesenAnzahlTotal',
      'activeOesenArt',
      'activeHohlsaum',
      'activeDrehverschluss',
      'checkVAT'
    ]),
    ...mapFields([
      'configuration.note'
    ])
  },
  async created () {
    try {
      const basics = await DataService.getBasics()
      this.minOrder = basics.B01.value
      this.VAT = basics.B02.value
      this.setVatRateFromBasics(basics.B02.value)
    } catch (err) {
      this.basicsLoadingError()
      console.log(err)
    }
  }
}
</script>

<style>
.kub-hersteller-link {
  color: #212529;
}

.kub-hersteller-link:hover {
  color: #212529;
  background-color: transparent;
}

.kub-price-summary {
  background-color: #f4f6f6;
}

#kub-price-button {
  color: #fff !important;
  background-color: #002b36 !important;
  border-color: #002b36 !important;
}
</style>
